import React from "react"
import { MdChatBubble, MdHistory, MdMap, MdPhone } from "react-icons/md"

const width = window.innerWidth
const height = window.innerHeight

const styles = {
    wrapper: {
        width,
        backgroundColor: "#141414",
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        padding: "10px 0",
        paddingBottom: 0,
        position: "fixed",
        bottom: 0
    },
    blocker: {
        position: "absolute",
        width,
        height,
        backgroundColor: "rgba(0,0,0,0.4)"
    },
    barView: {
        opacity: 0.5,
        backgroundColor: "red",
        width: 100,
        padding: "5px 0",
        borderRadius: 50,
        display: "flex",
        alignSelf: "center",
        margin: "10px 0",
    },
    buttonWraper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "10px 0",
        width: width / 4,
        
    }
}

export default function CompanyInfo({ menu, navigation }) {

    const Linking = {
        openURL: async function(to) {
            let a = document.createElement("a")
            a.href = to
            a.target = "blank"
            a.click()
        }
    }

    async function call() {

        await Linking.openURL("tel:+27603408655")

    }

    const email = () => navigation.navigate("chat")

    async function directions() {
        await Linking.openURL("https://www.google.com/maps/place/Makhwanya+M+E/@-22.95,30.4833333,11z/data=!4m5!3m4!1s0x0:0xaf9d6b9bb7ff5474!8m2!3d-22.95!4d30.4833333")
    }


    return (
        <>
            <div style={styles.wrapper}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div onClick={call} style={styles.buttonWraper}>
                        <MdPhone name="phone" size={27} color="red" />
                        <p style={{ fontSize: 13, color: "#FFF", marginTop: 5}}>Call</p>
                    </div>
                    <div onClick={email} style={styles.buttonWraper}> 
                        <MdChatBubble name="chat-bubble" size={27} color="red" />
                        <p style={{ fontSize: 13, color: "#FFF", marginTop: 5}}>Chat</p>
                    </div>
                    <div onClick={directions} style={styles.buttonWraper}> 
                        <MdMap name="map" size={27} color="red" />
                        <p style={{ fontSize: 13, color: "#FFF", marginTop: 5}}>Directions</p>
                    </div>
                    <div onClick={() => navigation.navigate("appointment")} style={styles.buttonWraper}> 
                        <MdHistory name="history" size={27} color="red" />
                        <p style={{ fontSize: 13, color: "#FFF", marginTop: 5}}>History</p>
                    </div>
                </div>
            </div>
        </>
    )
}
